/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import {
    object, func, shape, arrayOf, number,
} from 'prop-types';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import withStyles from '@material-ui/core/styles/withStyles';

const styles = ({ palette }) => ({
    personalizeWrapper: {
        marginRight: '16px',
        marginBottom: '10px',
    },
    personalizeText: {
        textAlign: 'right',
        paddingRight: '15px',
    },
    totalCharCount: {
        fontSize: '14px',
    },
    enterTextLabel: {
        color: palette.common.grey,
    },
});

class PersonalizeYourGift extends Component {
    constructor(props) {
        super(props);
        this.state = {
            totalCharCount: 0,
            personalizedText: '',
        };
    }

    componentDidMount = () => {
        const { totalCharCount } = this.state;
        const { handlePersonalizeInputChange } = this.props;

        handlePersonalizeInputChange(totalCharCount);
    }

    updatePersonalizedProdData = () => {
        const { personalizedText, totalCharCount } = this.state;
        const { getUpdatedPersonalizedProdData } = this.props;
        const personalizationData = {};
        if (personalizedText && totalCharCount > 0) {
            const personalizationLines = [];
            personalizationLines.push({
                perAttributeValue: personalizedText,
            });
            personalizationData.personalizationType = 'PRODUCT_PERSONALIZATION';
            personalizationData.personalizationLines = personalizationLines;
        }
        getUpdatedPersonalizedProdData(personalizationData);
    }

    handleChangePersonalizeText = (event) => {
        const { handlePersonalizeInputChange } = this.props;
        const valueCount = event.target.value.length;
        this.setState({
            totalCharCount: valueCount,
            personalizedText: event.target.value,
        }, () => {
            handlePersonalizeInputChange(valueCount);
            this.updatePersonalizedProdData();
        });
    }

    render() {
        const { classes, personalization } = this.props;
        const { totalCharCount } = this.state;
        let maxCharacters;
        if (personalization && personalization.lines) {
            const { lines } = personalization;
            lines.forEach((line) => {
                maxCharacters = line.maxChars;
            });
        }
        return (
            <div className={classes.personalizeWrapper}>
                <Grid container item alignItems="center" justify="flex-end" direction="row">
                    <Grid item lg={9} md={9} sm={9} className={classes.personalizeText}>
                        <Typography>
                            Personalize your item
                        </Typography>
                    </Grid>
                    <Grid item lg={3} md={3} sm={3}>
                        <TextField
                            required
                            id="outlined-basic"
                            label="Enter Text"
                            variant="outlined"
                            onChange={this.handleChangePersonalizeText}
                            inputProps={{ maxLength: maxCharacters }}
                            InputLabelProps={{
                                classes: {
                                    root: classes.enterTextLabel,
                                    focused: 'focused',
                                },
                            }}
                        />
                    </Grid>
                </Grid>
                <Grid container item justify="flex-end" direction="row">
                    <Typography className={classes.totalCharCount}>Charecter count: {totalCharCount}/{maxCharacters}</Typography>
                </Grid>
            </div>
        );
    }
}

PersonalizeYourGift.propTypes = {
    classes: object.isRequired,
    handlePersonalizeInputChange: func.isRequired,
    getUpdatedPersonalizedProdData: func.isRequired,
    personalization: shape({
        lines: arrayOf(
            shape({
                lineNumber: number,
                maxChars: number,
            }),
        ),
    }).isRequired,
};

export default withStyles(styles)(PersonalizeYourGift);
